import { Colors } from "@/enums/Colors";

function CircleHeartBeatAnimation() {
  return (
    <>
      <svg width="0.875rem" height="0.875rem" viewBox="0 0 24 24">
        <circle cx="50%" cy="50%" r="50%" fill={Colors.ELEGANT_BLACK}>
          <animate
            attributeType="XML"
            attributeName="fill"
            values={`#ddd;${Colors.ELEGANT_BLACK};#aaa;#ddd`}
            dur="0.5s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </>
  );
}

export default CircleHeartBeatAnimation;
